import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener
} from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import {
  FormFieldsGeneratorService,
  FormFields
} from '../../../shared/services/form-fields-generator.service';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import { GetItemListFieldsService } from '../../../shared/services/get-item-list-fields.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';

@Component({
  selector: 'ab-approval-popup',
  templateUrl: './approval-popup.component.html',
  styleUrls: ['./approval-popup.component.scss']
})
export class ApprovalPopupComponent implements OnInit, AfterViewInit {
  @ViewChild('approvalCodeInput') approvalCodeInput: ElementRef;

  public formFields: FormFields;
  public items: { [key: string]: Item };
  public challengeCode = 'NaN';
  public otpType: string;
  public approvalCodeErrorMessage: string;

  public approvalForm = new UntypedFormGroup({
    approvalCode: new UntypedFormControl(null, [
      Validators.required,
      Validators.pattern('[0-9]+')
    ])
  });

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    public dialogRef: MatLegacyDialogRef<ApprovalPopupComponent>,
    private formFieldsGeneratorService: FormFieldsGeneratorService,
    private getItemListFieldsService: GetItemListFieldsService
  ) {}

  get approvalCode() {
    return this.approvalForm.get('approvalCode');
  }

  @HostListener('document:keypress', ['$event'])
  onEnterPress(event) {
    if (event.key === 'Enter' && this.approvalForm.valid) {
      this.confirm();
      this.approvalCodeInput.nativeElement.blur();
    }
  }

  ngOnInit() {
    this.formFields = this.formFieldsGeneratorService.generateFormFields({
      fields: this.data.fields
    }) as FormFields;

    if (this.data.fields.items && this.data.fields.items.length !== 0) {
      this.items = this.getItemListFieldsService.getItems(
        this.data.fields.items
      );
    }

    if (this.data.approvalData && !this.data.approvalData.isRetail) {
      this.otpType = 'abopassValue';
    }

    this.challengeCode = this.data.approvalData.challengeCode;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.approvalCodeInput.nativeElement.focus();
    }, 1000);
  }

  radioChange() {
    setTimeout(() => this.approvalCodeInput.nativeElement.focus());
  }

  confirm() {
    const approveRequeset = this.data.approvalData.approveRequeset;
    if (approveRequeset) {
      approveRequeset({
        challengeCode: this.data.approvalData.challengeCode,
        signingCode: this.approvalForm.value.approvalCode
      }).subscribe((response) => {
        if (response.callIsSuccess) {
          this.dialogRef.close(true);
        } else {
          this.approvalCodeErrorMessage = response.errorDescription;
          this.approvalCode.setErrors({
            approvalCodeError: true
          });
        }
      });
    } else {
      this.dialogRef.close(this.approvalForm.value.approvalCode);
    }
  }
}
